'use strict';

try {
    module.exports.XMLHttpRequest = XMLHttpRequest;
} catch(error) {
    console.log('Warning: XMLHttpRequest is not defined');
    module.exports.XMLHttpRequest = null;
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/ethers-providers/browser-xmlhttprequest.js
// module id = 1862
// module chunks = 0